export default class DatabaseSyncError extends Error {
  constructor() {
    super('Houve um problema na sincronização com o servidor.');
    this.name = 'DatabaseSyncError';
  }
}
